import { Component, Vue } from "vue-property-decorator";

@Component
export default class ReplaceAmpm extends Vue {
  replaceAmpmInit(formatted: any) {
    return formatted.replace("AM", /午前/g) || formatted.replace("PM", /午後/g);
  }
}
